module.exports = __webpack_public_path__ + "static/media/boomapp_poster.bcb29924.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/projects/boomapp_poster.jpg
// module id = 178
// module chunks = 0